var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answers display--flex"},_vm._l((_vm.answers),function(answer,index){return _c('div',{key:("answer-" + (answer.id)),staticClass:"answers__answer position--relative display--flex",style:(("z-index: " + (_vm.zIndexes[index])))},[_c('base-field',{class:[ ( _vm.itsChainedScript ) ? 'answers__value answers__block' : 'answers__value--sequence' ],attrs:{"settings":{
                label: { class: _vm.generateLabelClass, text:  _vm.$t('global.optionWithNumber', { number: index + 1 }) },
                input: {
                    component: 'InputBasic',
                    id: ("question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    name: ("question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    class: 'field__input--default typography--default color--default',
                    disableClass: 'field__textarea--disable',
                    value: answer.value,
                    placeholder: _vm.$t('global.addOptionWithNumber', { number: index + 1 }),
                    isMissing: _vm.isMissing
                },
                emitToParent: true,
                isEdition: _vm.isEdition,
                reset: _vm.reset,
                allowFilling: _vm.allowFilling
            }},on:{"get-value":function($event){return _vm.toggleAnswers( $event, answer.id )}}}),(answer.value)?_c('button-with-icon',{staticClass:"answers__delete position--absolute",attrs:{"icon":{
                component: function () { return import(
                    /* webpackChunkName: 'IconTrash' */ '@/components/bundles/layout/images/icons/IconTrash'
                ); },
                class: 'answers__delete__icon'
            },"aria-label":_vm.$t('accessibility.delete'),"action":{
                execute: true,
                function: function () { return _vm.deleteAnswer( answer.id ); }
            }}}):_vm._e(),(_vm.itsChainedScript)?_c('base-field',{staticClass:"answers__block",attrs:{"settings":{
                label: { class: _vm.generateLabelClass, text: _vm.$t('global.nextQuestion') },
                input: {
                    component: 'InputAutocomplete',
                    id: ("next-question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    name: ("next-question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    type: 'text',
                    value: '',
                    targetClass: 'field__input--default typography--default color--default',
                    disableClass: 'field__textarea--disable',
                    browserAutocomplete: 'off',
                    placeholder: _vm.$t('global.nextQuestion'),
                    dynamicData: {
                        data: _vm.questions,
                        apiValue: answer.nextQuestion
                    }
                },
                isEdition: _vm.isEdition,
                reset: _vm.reset,
                allowFilling: _vm.allowFilling
            }}}):_vm._e(),(parseInt( _vm.questionType, 10 ) !== 4)?_c('base-field',{class:[ ( _vm.itsChainedScript ) ? 'answers__additional-info answers__block' : 'answers__additional-info--sequence' ],attrs:{"settings":{
                label: { class: 'capitalize', text: _vm.$t('global.additionalAnswer') },
                input: {
                    component: 'InputCheckbox',
                    id: ("additional-behaviour-question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    name: ("additional-behaviour-question[" + _vm.questionId + "]-answer[" + (answer.id) + "]"),
                    type: 'checkbox',
                    class: 'field__input--checkbox',
                    value: answer.additionalBehaviour,
                    browserAutocomplete: 'off',
                    isRequired: false
                },
                isEdition: _vm.isEdition,
                reset: _vm.reset,
                allowFilling: true
            }}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }